import markdownit from 'markdown-it';

export default function renderMarkdown(input, html = true) {
  const md = markdownit({ html });
  return md.render(input
    // pre-process
    .replace(/<(?!\w*:\/\/)([^\s]+\.[^\s]+)>/g, '<https://$1>') // all links are absolute
  )
    // post-process
    .replace(/<a[ >]/g, '<a target="_blank" ') // all links target new tab/window
    .replace(/href="((?!\w+:\/\/)[^"]+)"/g, 'href="https://$1"') // all links are absolute
    .replace(/<table>/g, '<table class="table table-striped table-hover">') // style tables
    .replace(/<img[ >]/g, '<img style="max-width: 80%; max-height: 200vh; object-fit: contains;" '); // resize images
}



// WEBPACK FOOTER //
// ./src/utils/markdown.js